import { Flex, Image } from "@chakra-ui/react"

import LoadingGif from '../../assets/loading/tres_pontos.gif';

const Loading: React.FC = () => {
	return (
		<Flex
			flex={1}
			justify="center"
			align="center"
			width="100%"
			height="100%"
			position="fixed"
			bg="rgba(0, 0, 0, 0.3)"
			z-index={9999999999}
		>

			<Image src={LoadingGif} alt="" w="100" h="100" />
		</Flex>
	)
}

export default Loading;
